import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllAccounts, decrementCurrentWizardStep, incrementCurrentWizardStep, resetAccountResultsLoaded, resetCurrentWizardStep, resetSelectAllAccounts, resetSelectedAccounts, selectAccount, selectGroup, setAccountResultsLoaded, setImportType, setPortfolioImportType, setSearchType, toggleSelectAllAccounts, } from './import-holdings.actions';
import { BROADRIDGE_ACCOUNT } from 'IntegrationsApp/ts/constants';
import { CLIENT_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(resetCurrentWizardStep, () => {
    return 0;
}));
export const searchType = createReducer(BROADRIDGE_ACCOUNT, on(setSearchType, (state, { searchType: newSearchType }) => {
    return newSearchType;
}));
export const selectedGroup = createReducer(null, on(selectGroup, (state, { selectedGroup: newGroup }) => {
    return newGroup;
}));
export const portfolioImportType = createReducer(CLIENT_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => {
    return newPortfolioImportType;
}));
export const selectedAccounts = createReducer([], on(selectAccount, (state, { selectedAccountId: newAccountId }) => {
    if (state.map((account) => account.id).includes(newAccountId)) {
        return state.filter((account) => account.id !== newAccountId);
    }
    return [...state, { id: newAccountId, importAsSingleHolding: false }];
}), on(setImportType, (state, { id, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(id)) {
        return state.map((account) => {
            if (account.id === id) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id, importAsSingleHolding }];
}), on(addAllAccounts, (state, { accounts }) => {
    return accounts.map((account) => {
        return { id: account.AccountID, importAsSingleHolding: false };
    });
}), on(resetSelectedAccounts, () => {
    return [];
}));
export const selectAllAccounts = createReducer(false, on(toggleSelectAllAccounts, (state) => {
    return !state;
}), on(resetSelectAllAccounts, () => {
    return false;
}));
export const accountResultsLoaded = createReducer(false, on(setAccountResultsLoaded, (state, action) => {
    return action.loaded;
}), on(resetAccountResultsLoaded, () => {
    return false;
}));
export const broadridgeImportHoldings = combineReducers({
    currentWizardStepIndex,
    searchType,
    selectedGroup,
    selectedAccounts,
    selectAllAccounts,
    portfolioImportType,
    accountResultsLoaded,
});
